import * as React from "react";
import UnstyledButton from "../UnstyledButton/UnstyledButton";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { Text } from "src/components/Text";
import "./CalypsoButton.scss";

interface IProps {
    title: string;
    text?: string;
    icon?: string;
    onClick?: any;
    theme?: "light" | "primary";
    classNames?: string[];
    reversed?: boolean;
}

const CalypsoButton = (props: IProps) => {
    const isColored = props.theme === "primary";

    return (
        <UnstyledButton
            className={
                [
                    ...(props.classNames || []),
                    "CalypsoButton",
                    !props.text ? "icon-only" : "",
                    isColored ? "primaryBGColor" : "",
                    props.reversed ? "reversed" : "",
                    props.icon?.toLowerCase() === "add" ? "add-button" : ""
                ].filter(x => x).join(" ")
            }
            title={props.title}
            onClick={props.onClick}>
            {props.icon && <div className="icon-wrapper">
                <Visage2Icon icon={props.icon} color={isColored ? "white" : "dark-grey"} size={props.icon === "add" ? "medium" : "small"} />
            </div>}
            {props.text && <Text size="caption" color={isColored ? "white" : "grayDark"}>{props.text}</Text>}
        </UnstyledButton>
    )
}

export default CalypsoButton;
